import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { EmailService } from '../../services/email.service';
import { AlertService } from '../../services/alert.service';

function atLeastOneContactMethod(control: AbstractControl): ValidationErrors | null {
  const email = control.get('email')?.value?.trim();
  const phone = control.get('phone')?.value?.trim();
  return email || phone ? null : { atLeastOneContact: true };
}

@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputComponent],
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent {
  @Input() showCancel: boolean = false;
  @Output() submitted = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  isSubmitting: boolean = false;

  contactForm: FormGroup = new FormGroup(
    {
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl(''),
      phone: new FormControl(''),
      message: new FormControl(''),
    },
    { validators: atLeastOneContactMethod }
  );

  constructor(
    private emailService: EmailService,
    private alertService: AlertService
  ) {}

  get contactMethodMissing(): boolean {
    return this.contactForm.hasError('atLeastOneContact') &&
      !!(this.contactForm.get('email')?.touched || this.contactForm.get('phone')?.touched);
  }

  onSubmit() {
    this.contactForm.markAllAsTouched();

    if (!this.contactForm.get('firstName')?.valid || !this.contactForm.get('lastName')?.valid) {
      this.alertService.showSnackBar('First and last name are required.');
      return;
    }

    if (this.contactForm.hasError('atLeastOneContact')) {
      this.alertService.showSnackBar('Please provide an email address or phone number.');
      return;
    }

    this.isSubmitting = true;

    this.emailService.sendCustomerContactRequest({
      firstName: this.contactForm.get('firstName')!.value.trim(),
      lastName: this.contactForm.get('lastName')!.value.trim(),
      email: this.contactForm.get('email')!.value?.trim() || undefined,
      phone: this.contactForm.get('phone')!.value?.trim() || undefined,
      message: this.contactForm.get('message')!.value?.trim() || undefined,
    }).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.alertService.showSnackBar('Message sent! We\'ll be in touch soon.');
        this.contactForm.reset();
        this.submitted.emit();
      },
      error: () => {
        this.isSubmitting = false;
        this.alertService.showSnackBar('Failed to send message. Please try again.');
      }
    });
  }

  onCancel() {
    this.cancelled.emit();
  }
}
